import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type Props = {
  id: string;
  enabled?: boolean;
};

export const companyOwnershipQueryKey = (id: string) => ["company-ownership", id];

export const useCompanyOwnership = ({ id, enabled }: Props) => {
  const { apiClient } = useSalesyApiClient();

  return useQuery({
    queryKey: companyOwnershipQueryKey(id),
    queryFn: () => apiClient.companyDetails.getOwnerships({ id }),
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
};
